import React, { useEffect, useState, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { Link } from "react-router-dom";
import Api from "../../Hooks/Api";
const ProductsPerCountyReport = (props) => {
  const [state, setState] = useState([]);
  const [responsemessage, setresponsemessage] = useState("");
  const fetchData = () => {
    setresponsemessage("");
    setState([]);

    let url = "api/reports/productsPerRegionReport";
    Api.get(url)
      .then(function (response) {
        if (response.data.length == 0) {
          setresponsemessage("No data found");
        }
        setState(response.data);
      })
      .catch(function (error) {})
      .then(function () {
        // always executed
      });
  };
  useEffect(() => {
    fetchData();
  }, []);
  const convertTimestampToDate = (timeStamp) => {
    return new Date(timeStamp).toLocaleDateString("en-US");
  };
  const printRef = useRef();
  const handlePrint = useReactToPrint({
    contentRef: printRef, // ✅ new API for v3+
    documentTitle: "My PDF Document",
  });
  const MyComponentToPrint = React.forwardRef((props, ref) => (
    <div className="row" ref={ref}>
      <div className="col-sm-12">
        <h5 className="text-center">Ministry of Tourism and Wildlife</h5>
        <h5 className="text-center">National Tourism Service Portal</h5>
        <h5 className="text-center">
          No of Tourism Products/Sites per Region and County
        </h5>
        <table class="table table-striped">
          <thead>
            <tr>
              {/* <th scope="col">Id</th>
               */}

              <th scope="col">Region/Circuit </th>
              <th scope="col">Counties</th>
              <th scope="col">No. of Products</th>
            </tr>
          </thead>
          <tbody>
            {state.map((k) => {
              return (
                <tr>
                  <td>{k.region}</td>

                  <td>{k.numberOfCounties}</td>
                  <td>{k.numberOfProducts}</td>
                </tr>
              );
            })}
            <tr>
              <td>Total</td>

              <td>
                {state.reduce(
                  (sum, item) => sum + Number(item.numberOfCounties),
                  0,
                )}
              </td>
              <td>
                {state.reduce(
                  (sum, item) => sum + Number(item.numberOfProducts),
                  0,
                )}
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="4">DATE: {convertTimestampToDate(Date.now())} </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div className="col-sm-2"></div>
    </div>
  ));

  return (
    <div id="content" className="content">
      <ol class="breadcrumb float-xl-right">
        <li class="breadcrumb-item">
          {" "}
          <Link to="/">Home </Link>{" "}
        </li>
        <li class="breadcrumb-item active">Products/Sites per Region</li>
      </ol>
      <h1 class="page-header mb-3">Products/Sites per Region</h1>
      <div style={{ backgroundColor: "white" }}>
        <hr />

        <div className="col-sm-12">
          <div className="row">
            <div className="col-sm-3">
              <button
                onClick={handlePrint}
                style={{
                  padding: "10px 15px",
                  background: "#28a745",
                  color: "white",
                  border: "none",
                  borderRadius: "6px",
                }}
              >
                Print to PDF
              </button>
            </div>
          </div>
          {state.length > 0 ? (
            <div ref={printRef}>
              <MyComponentToPrint ref={printRef} />
            </div>
          ) : null}
        </div>

        <h3>{responsemessage}</h3>
      </div>
    </div>
  );
};
export default ProductsPerCountyReport;
